import axios from "axios";
import { configUrl } from "config";



export const getAllPackages = async () => {
    try {
        const res = await axios.get(`${configUrl.AssessmentServer}/api/package/getAllPackages`);
        // API returns {$values: []}
        return res?.data?.$values || [];
    } catch (error) {
        console.error("Error fetching packages:", error);
        return [];
    }
};
